import { render, staticRenderFns } from "./intergralList.vue?vue&type=template&id=2a71973f&scoped=true&"
import script from "./intergralList.vue?vue&type=script&lang=js&"
export * from "./intergralList.vue?vue&type=script&lang=js&"
import style0 from "./intergralList.vue?vue&type=style&index=0&id=2a71973f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a71973f",
  null
  
)

export default component.exports